{
  "translatedFrom": "Translated from {{lang}} — show original",
  "originalShown": "Original ({{lang}}) — show translation",
  "translationPending": "Original ({{lang}}) — translation pending",
  "allSourcesRetired": "All Sources Retired",
  "unknown": "Unknown",
  "sourcesCount_one": "{{count}} source",
  "sourcesCount_other": "{{count}} sources",
  "retiredCount_one": "{{count}} retired",
  "retiredCount_other": "{{count}} retired",
  "workflowRetired": "RETIRED — No longer available",
  "interested": "Interested",
  "notInterested": "Not Interested",
  "visit": "Visit:",
  "address": "Address:",
  "comment": "Comment:",
  "list": {
    "noAdsTitle": "No ads available",
    "noAdsSubtitle": "Check back later for new property listings matching your criteria.",
    "count_one": "{{count}} Property Found",
    "count_other": "{{count}} Properties Found"
  },
  "map": {
    "notAvailable": "Map not available — address could not be geocoded",
    "propertyLocation": "Property location"
  },
  "sources": {
    "failedToLoad": "Failed to load sources",
    "failedToUnmerge": "Failed to unmerge source",
    "activeSources": "Active Sources",
    "multipleSourcesHint": "This ad was found on multiple websites. The primary source provides the ad details.",
    "singleSourceHint": "Current source for this ad.",
    "retiredSources": "Retired Sources",
    "retiredHint": "These sources are no longer available on their websites.",
    "primary": "Primary",
    "primaryForced": "Forced",
    "priceDiffers": "Price differs",
    "view": "View",
    "retiredDetail": "Retired: {{retiredDate}} | Imported: {{importDate}}",
    "activeDetail": "Last seen: {{lastSeenDate}} | Imported: {{importDate}}",
    "unmergeTooltip": "Unmerge this source into a separate ad",
    "unmergeDialogTitle": "Unmerge Source?",
    "unmergeDialogBody": "This will split the source from {{website}} into a separate ad. The original ad will keep its other sources.",
    "unmerge": "Unmerge",
    "setPrimaryTooltip": "Set as primary source",
    "resetToAutomaticTooltip": "Reset to automatic primary source",
    "failedToSetPrimary": "Failed to set primary source",
    "failedToResetPrimary": "Failed to reset primary source"
  },
  "mortgage": {
    "title": "Mortgage Simulation",
    "resetToDefaults": "Reset to defaults",
    "noPriceError": "Ad has no price to simulate a mortgage for",
    "recalculateError": "Failed to recalculate mortgage",
    "resetError": "Failed to reset mortgage simulation",
    "page": {
      "title": "Mortgage Simulator",
      "loadError": "Failed to load the mortgage simulation"
    },
    "warnings": {
      "INSUFFICIENT_EQUITY": "Insufficient equity: the down payment is below the recommended minimum share of the purchase price.",
      "DOWN_PAYMENT_COVERS_PRICE": "Down payment covers the full purchase price — no loan required.",
      "EFFORT_RATIO_EXCEEDED": "Effort ratio exceeds the maximum recommended share of household income."
    },
    "fields": {
      "price": "Purchase price (CHF)",
      "down_payment": "Down payment (CHF)",
      "interest_rate": "Interest rate (%)",
      "term_years": "Fixed term (years)",
      "maintenance_rate": "Maintenance & charges (%)",
      "purchase_costs_rate": "Purchase costs (%)",
      "amortization_target_ltv": "Amortization target LTV (%)",
      "amortization_years": "Amortization period (years)",
      "stress_test_rate": "Stress-test rate (%)",
      "max_effort_ratio": "Max effort ratio (%)",
      "annual_income": "Household annual income (CHF)"
    },
    "downPayment": {
      "title": "Down payment",
      "percentLabel": "Share of price (%)",
      "helper": "Min {{minPercent}} = {{minAmount}} · Max {{maxAmount}}",
      "sliderAria": "Adjust the amount using the slider"
    },
    "results": {
      "loan_amount": "Loan amount",
      "ltv": "Loan-to-value",
      "total_cash_needed": "Total cash needed",
      "annual_interest": "Annual interest",
      "annual_amortization": "Annual amortization",
      "annual_maintenance": "Annual maintenance",
      "annual_cost": "Annual cost",
      "monthly_cost": "Monthly cost",
      "theoretical_annual_cost": "Theoretical annual cost (stress test)",
      "required_income": "Required annual income",
      "effort_ratio": "Effort ratio",
      "total_interest_over_term": "Total interest over fixed term"
    },
    "charts": {
      "fundingTitle": "Funding structure",
      "monthlyTitle": "Monthly cost breakdown",
      "effortTitle": "Effort ratio gauge",
      "segments": {
        "downPayment": "Down payment",
        "loanAmount": "Loan amount",
        "purchaseCosts": "Purchase costs",
        "interest": "Interest",
        "amortization": "Amortization",
        "maintenance": "Maintenance"
      },
      "includePurchaseCosts": "Include purchase costs",
      "titleWithTotal": "{{title}} ({{total}})",
      "amortizationNote": "Amortization builds equity in the property rather than being a pure cost.",
      "effortNote": "Based on the theoretical stress-test cost, not the actual monthly cost above.",
      "maxEffortMarker": "Max recommended: {{value}}"
    }
  },
  "page": {
    "title": "Property Listings",
    "subtitle": "Browse and manage real estate ads matching your criteria",
    "criteriaSet": "Criteria Set",
    "allCriteriaUnion": "All Criteria (Union)",
    "loadingAds": "Loading ads...",
    "failedToLoadTitle": "Failed to Load Ads",
    "untitled": "Untitled",
    "noAdsInStage": "No ads in this stage yet.",
    "retiredTab": "Retired",
    "scheduleVisit": "Schedule Visit",
    "discard": "Discard",
    "markVisited": "Mark Visited",
    "markBought": "Mark Bought",
    "markAsVisitedTitle": "Mark as Visited",
    "markAsVisitedDescription": "Please provide your comments about the visit.",
    "discardAdTitle": "Discard Ad",
    "discardAdDescription": "Please provide a reason for discarding this ad.",
    "markAsBoughtTitle": "Mark as Bought",
    "markAsInterestedToBuyTitle": "Mark as Interested to Buy",
    "confirmBoughtMessage": "Are you sure you want to mark this property as bought?",
    "confirmInterestedToBuyMessage": "Are you sure you want to mark this property as interested to buy?",
    "notInterestedTitle": "Not Interested - Add Comment",
    "notInterestedDescription": "Please provide a reason why you're not interested in this property."
  },
  "detail": {
    "moveToRetired": "Move to Retired",
    "allSourcesRetiredTitle": "All sources for this ad have been retired",
    "allSourcesRetiredMessage": "This ad is no longer available on any website. You can only move it to retired status.",
    "priceMismatchTitle": "Sources disagree on price",
    "priceMismatchMessage": "One or more secondary sources list a different price than the one shown here. See \"All Sources\" below for details.",
    "priceLabel": "Price",
    "sizeLabel": "Size",
    "roomsLabel": "Rooms",
    "addressHeading": "Address",
    "edited": "Edited",
    "editAddress": "Edit address",
    "matchingCriteria": "Matching Criteria",
    "description": "Description",
    "additionalDetails": "Additional Details",
    "floor": "Floor:",
    "yearBuilt": "Year Built:",
    "propertyType": "Property Type:",
    "status": "Status:",
    "visitDate": "Visit Date:",
    "visitAddress": "Visit Address:",
    "source": "Source",
    "viewOriginal": "View Original",
    "dates": "Dates",
    "imported": "Imported: {{date}}",
    "comments": "Comments",
    "addComment": "Add Comment",
    "noComments": "No comments yet.",
    "statusHistory": "Status History",
    "noStatusChanges": "No status changes yet.",
    "addressUpdated": "Address updated",
    "addressUpdateFailed": "Failed to update address",
    "flaggedInterested": "Ad flagged as interested!",
    "flagFailed": "Failed to flag ad",
    "flaggedNotInterested": "Ad flagged as not interested",
    "statusUpdated": "Status updated!",
    "actionFailed": "Action failed",
    "commentAdded": "Comment added!",
    "commentAddFailed": "Failed to add comment",
    "markAsVisitedDescription": "Add a comment about the visit.",
    "addCommentDialogDescription": "Add a comment to this property's workflow.",
    "statusComment": "Comment:",
    "editVisitDate": "Edit visit date",
    "editVisitAddress": "Edit visit address",
    "editStatusComment": "Edit comment",
    "addVisitDate": "Add visit date",
    "addVisitAddress": "Add visit address",
    "addStatusComment": "Add status comment",
    "visitDateUpdated": "Visit date updated",
    "visitDateUpdateFailed": "Failed to update visit date",
    "visitAddressUpdated": "Visit address updated",
    "visitAddressUpdateFailed": "Failed to update visit address",
    "statusCommentUpdated": "Comment updated",
    "statusCommentUpdateFailed": "Failed to update comment",
    "editedBy": "Edited by {{user}}, {{time}}",
    "fieldChanges": "Field Changes",
    "noFieldChanges": "No field changes yet.",
    "fieldChangeValue": "{{oldValue}} → {{newValue}}",
    "fieldChangeEmpty": "(empty)",
    "fieldNames": {
      "address": "Address",
      "visit_date": "Visit Date",
      "visit_address": "Visit Address",
      "status_comment": "Comment",
      "primary_source": "Primary Source"
    },
    "deleteAd": "Delete",
    "deleteAdTitle": "Delete this ad?",
    "deleteAdMessage": "\"{{title}}\" and everything linked to it (sources, workflow, comments, history) will be permanently deleted. If the listing is still online, the scraper may re-import it on its next run.",
    "adDeleted": "Ad deleted",
    "deleteFailed": "Failed to delete ad"
  }
}
